import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Component: Pinned Features
 */

export default class PinnedFeatures {
    constructor() {
        this.selectors = {
            root: '[data-pinned-features]',
            panels: '[data-pinned-features-panel]',
            panelText: '[data-pinned-features-panel-text]',
            panelMedia: '[data-pinned-features-media]',
            panelMediaImage: '[data-pinned-features-media-image]'
        };

        this.body = document.body;
        this.rootElem = document.querySelector(this.selectors.root);

        if (!this.rootElem) return;

        this.panelElems = this.rootElem.querySelectorAll(this.selectors.panels);
        this.panelMedia = this.rootElem.querySelector(this.selectors.panelMedia);
        this.panelMediaImages = this.panelMedia.querySelectorAll(this.selectors.panelMediaImage);

        this.init();
    }

    setTweens() {
        var panelElemsArr = Array.prototype.slice.call(this.panelElems);

        if (!panelElemsArr.length) return;

        // scroll trigger for each panel

        panelElemsArr.forEach((panel, index) => {
            var panelTextElem = panel.querySelector(this.selectors.panelText);
            var isDarkPanel = panel.hasAttribute('data-pinned-features-panel-dark');
            var imageElem = this.panelMediaImages[index];

            gsap.to(panelTextElem, {
                scrollTrigger: {
                    trigger: panelTextElem,
                    start: '+=150px bottom',
                    toggleActions: 'play none none reset'
                    // markers: true,
                },
                opacity: 1
            });

            // image swap in iphone frame condition

            if (index > 0) {
                gsap.to(imageElem, {
                    scrollTrigger: {
                        trigger: panelTextElem,
                        start: '+=150px bottom',
                        toggleActions: 'play complete pause reset'
                        // markers: true,
                    },
                    opacity: 1,
                    visibility: 'visible'
                });
            }

            // dark panel condition

            if (isDarkPanel) {
                gsap.to(this.rootElem, {
                    scrollTrigger: {
                        trigger: panelTextElem,
                        start: '+=150px bottom',
                        toggleActions: 'play complete pause reset'
                        // markers: true,
                    },
                    backgroundColor: '#171717',
                    color: '#FFFFFF'
                });
            }
        });

        // scroll trigger for panel media

        gsap.to(this.panelMedia, {
            scrollTrigger: {
                trigger: this.rootElem,
                pin: this.panelMedia,
                anticipatePin: 1,
                pinSpacing: false,
                start: 'top',
                end: 'bottom bottom'
                // markers: true,
            }
        });
    }

    bindEvents() {
        // force ScrollTrigger refresh to re-calc start/end positions on resize
        $(window).on('resize', () => {
            ScrollTrigger.refresh();
        });

        $(document).ready(() => {
            this.setTweens();
        });
    }

    init() {
        this.bindEvents();
    }
}
